module.exports = __webpack_public_path__ + "static/media/hell-yeah-or-no.fdc1ed38.png";